import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ZoneResponse } from '@key-telematics/fleet-api-client';
import { TranslateService } from '@ngx-translate/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { MapComponent, MapControls, MapZonesService } from 'app/shared/components';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { ListSectionHandler } from '../../entities/shared/list.section';

@Component({
    selector: 'key-admin-zone-editor',
    templateUrl: './zone-editor.component.html',
    styleUrls: ['./zone-editor.component.scss'],
    providers: [MapZonesService]
})
export class AdminZoneEditorComponent extends BaseComponent implements OnChanges, OnDestroy, AfterViewInit {

    @Input() entity: ZoneResponse;
    @Input() handler: ListSectionHandler;
    @Input() editable: boolean;

    @Output() onEditing = new EventEmitter<boolean>();
    @Output() onSaving = new EventEmitter<any>();
    @Output() onSaved = new EventEmitter<any>();

    @ViewChild('map', { static: true }) map: MapComponent;

    mapControls = [
        MapControls.fullscreen,
        MapControls.simplezoneedit,
        MapControls.layers,
    ];

    errorMessage: string;

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        public zonesService: MapZonesService,
        private ref: ChangeDetectorRef
    ) {
        super();
    }

    ngOnDestroy() {
        this.zonesService.detachMap();
    }

    ngAfterViewInit() {
        this.zonesService.attachMapAndZone(this.map, this.entity);
        setTimeout(() => {
            this.map.invalidate(); // make sure the map redraws itself once the DOM has settled

            // update other editors when changes was made to the map
            this.on(this.map.onZonesEdited, e => {
                const zone = {
                    ...this.entity,
                    ...e.zones.find(x => x.id === this.entity.id),
                };
                this.onSaved.emit(zone);
            });

        }, 100);
    }


    ngOnChanges(changes: SimpleChanges) {
        if (changes.handler && this.handler) {
            this.load().catch(err => this.showError(err));
        }
    }

    async load(): Promise<void> {
        this.errorMessage = null;
        if (this.entity) {
            setTimeout(() => {
                this.map.invalidate();
                this.map.zoomToBounds(this.entity.bounds);
            }, 100);
        }
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();

    }



}
